function endlessScroll(container, offset) {
  $('.pagination').hide();
  const $container = $(container);
  $container.off('scroll').scroll(() => {
    const url = $container.find('.pagination span.next a').attr('href');
    if (url
      && $container.scrollTop() + $container.innerHeight() >= $container[0].scrollHeight - offset) {
      $('.pagination').text('Fetching more');
      $.getScript(url);
    }
  });
}

$(document).on('ready turbolinks:load', () => {
  endlessScroll('.endless-scroll', 1000);
});
